export const NUMBER_OFFER_MAX = 5;

export const PAYMENT_TYPE = [
    { value: "BILL_PAY_SINGLE_LINE", label: "Postpay single line" },
    { value: "BILL_PAY_MULTI_LINE", label: "Postpay multi line" },
    { value: "PAYG_REGISTERED", label: "Prepay registered" },
    { value: "PAYG_UNREGISTERED", label: "Prepay unregistered" },
];

export const BUILDING_TYPE = [
    { value: "HOUSE" },
    { value: "BLOCK_OF_FLATS" },
    { value: "SHOP" },
    { value: "MAISONETTE" },
    { value: "OFFICE" },
    { value: "STUDIO" },
    { value: "VILLA" },
    { value: "WAREHOUSE" },
    { value: "FACTORY" },
    { value: "AIRPORT" },
    { value: "PORT" },
    { value: "PARK" },
    { value: "HOTEL" },
];

export const BUILDING_TYPES = [
    "HOUSE",
    "BLOCK_OF_FLATS",
    // "SHOP",
    // "MAISONETTE",
    // "OFFICE",
    // "STUDIO",
    // "VILLA",
    // "WAREHOUSE",
    // "FACTORY",
    // "AIRPORT",
    // "PORT",
    // "PARK",
    // "HOTEL",
];

export const DONOR_PROVIDERS = [
    { value: "OT", label: "epic" },
    { value: "CN", label: "Cablenet" },
    { value: "CP", label: "CYTA" },
    { value: "PR", label: "Primetel" },
];

export const SUBSCRIPTION_TYPES = [
    { value: "PS", label: "Postpaid" },
    { value: "PR", label: "Prepaid" },
];

const CART_PAGE_URL_EN = "/en/cart";
const CART_PAGE_URL_EL = "/el/cart";
const HOME_PAGE_URL_EN = "/en/home";
const HOME_PAGE_URL_EL = "/el/home";
const DETAILS_PAGE_URL_EN = "/en/customerDetails";
const DETAILS_PAGE_URL_EL = "/el/customerDetails";
const SUMMARY_PAGE_URL_EN = "/en/summary";
const SUMMARY_PAGE_URL_EL = "/el/summary";
const CONFIRMATION_PAGE_URL_EN = "/en/confirmation";
const CONFIRMATION_PAGE_URL_EL = "/el/confirmation";
const MYACCOUNT_URL_EN = "/en/home";
const MYACCOUNT_URL_EL = "/el/home";
const ESHOP_URL_EN = "/en/home";
const ESHOP_URL_EL = "/el/home";
const WORDPRESS_HOME_URL_EN = "/en/home";
const WORDPRESS_HOME_URL_EL = "/el/home";
const WORDPRESS_ABOUT_URL_EN = "/en/about-gomo";
const WORDPRESS_ABOUT_URL_EL = "/el/about-gomo";
const WORDPRESS_HELP_URL_EN = "/el/help-support";
const WORDPRESS_HELP_URL_EL = "/el/help-support";
const WORDPRESS_PRICING_URL_EN = "/en/pricing";
const WORDPRESS_PRICING_URL_EL = "/el/pricing";
const WORDPRESS_TERM_URL_EN = "/en/terms";
const WORDPRESS_TERM_URL_EL = "/el/terms";
const WORDPRESS_LEGAL_URL_EN = "/en/legal";
const WORDPRESS_LEGAL_URL_EL = "/el/legal";
const WORDPRESS_PRIVACY_URL_EN = "/en/privacy";
const WORDPRESS_PRIVACY_URL_EL = "/el/privacy";
const WORDPRESS_COOKIES_URL_EN = "/en/cookies";
const WORDPRESS_COOKIES_URL_EL = "/el/cookies";
const WORDPRESS_GETTING_STARTED_URL_EN = "/en/joining-getting-started-with-gomo";
const WORDPRESS_GETTING_STARTED_URL_EL = "/el/joining-getting-started-with-gomo";
const WORDPRESS_ROAMING_URL_EN = "/en/our-roaming-rates";
const WORDPRESS_ROAMING_URL_EL = "/el/our-roaming-rates";
const TWO_WAY_AUTH_OTP_URL_EN = "/en/two_way_auth";
const TWO_WAY_AUTH_OTP_URL_EL = "/el/two_way_auth";

export const ROUTES = {
    CART_PAGE_URL_EN,
    CART_PAGE_URL_EL,
    CONFIRMATION_PAGE_URL_EN,
    CONFIRMATION_PAGE_URL_EL,
    DETAILS_PAGE_URL_EN,
    DETAILS_PAGE_URL_EL,
    HOME_PAGE_URL_EN,
    HOME_PAGE_URL_EL,
    SUMMARY_PAGE_URL_EN,
    SUMMARY_PAGE_URL_EL,
    MYACCOUNT_URL_EN,
    MYACCOUNT_URL_EL,
    ESHOP_URL_EN,
    ESHOP_URL_EL,
    WORDPRESS_HOME_URL_EN,
    WORDPRESS_HOME_URL_EL,
    WORDPRESS_ABOUT_URL_EN,
    WORDPRESS_ABOUT_URL_EL,
    WORDPRESS_HELP_URL_EN,
    WORDPRESS_HELP_URL_EL,
    WORDPRESS_PRICING_URL_EN,
    WORDPRESS_PRICING_URL_EL,
    WORDPRESS_TERM_URL_EN,
    WORDPRESS_TERM_URL_EL,
    WORDPRESS_LEGAL_URL_EN,
    WORDPRESS_LEGAL_URL_EL,
    WORDPRESS_PRIVACY_URL_EN,
    WORDPRESS_PRIVACY_URL_EL,
    WORDPRESS_COOKIES_URL_EN,
    WORDPRESS_COOKIES_URL_EL,
    WORDPRESS_GETTING_STARTED_URL_EN,
    WORDPRESS_GETTING_STARTED_URL_EL,
    WORDPRESS_ROAMING_URL_EN,
    WORDPRESS_ROAMING_URL_EL,
    TWO_WAY_AUTH_OTP_URL_EN,
    TWO_WAY_AUTH_OTP_URL_EL,
};

export const { WORDPRESS_URL } = process.env;
export const { ESHOP_URL } = process.env;

export const GTM = {
    TRANSACTION_SHIPPING_COST: 0,
    TRANSACTION_TAX_COST: 0,
};

export const OFFER_CONFIG = {
    BRAND: "GOMO",
    CHANNEL: "ESHOP",
    CHANNEL_TYPE: "DIRECT",
    CUSTOMER_TYPE: "residential",
    OFFER_TYPE: "POSTPAY",
};

export const BRAND_NAME = "GoMo";

export const HELP_SUPPORT_URL = `${WORDPRESS_URL}/help-support/`;

export enum EPAYMENT_TYPES {
    CREDIT_CARD = "CREDIT_CARD",
}
